import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import SmartIcon from '../SmartIcon';
import Image from 'next/image';
import Styles from './index.module.scss';

import LOGO  from '@/public/assets/images/logo.png';

const DownloadHint = ({
  callback,
}) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  return (
    <div
      className={Styles.root}
      onClick={callback}
      role="button"
      tabIndex={0}
      onKeyDown={() => {}}
    >
      <div className={Styles.container}>
        <div className={Styles.logo}>
          <Image 
            layout="fill"
            src={LOGO.src}
            objectFit="cover"
            alt="app logo"
          />
        </div>
        <div className={Styles.description}>
          <FormattedMessage id="common:open_in_browser" />
        </div>
        <SmartIcon className={Styles.bendingArrow} icon="bending-arrow" />
      </div>
    </div>
  );
};

DownloadHint.propTypes = {
  callback: PropTypes.func,
};

DownloadHint.defaultProps = {
  callback: () => {},
};

export default DownloadHint;
